import { render } from "./Platforms.vue?vue&type=template&id=28aa42ea&scoped=true&ts=true"
import script from "./Platforms.vue?vue&type=script&lang=ts"
export * from "./Platforms.vue?vue&type=script&lang=ts"

import "./Platforms.vue?vue&type=style&index=0&id=28aa42ea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28aa42ea"]])

export default __exports__